<template>
  <v-dialog v-model="show" width="500">
    <template #activator="{attrs, on}">
      <v-btn v-bind="attrs" v-on="on" small>
        Tilføj lokation
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>Tilføj lokation</v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="selectedLocations"
          :items="availableLocations"
          small-chips
          item-text="title"
          item-value="id"
          label="Vælg lokationer"
          multiple
          append-
        >
          <template #item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-chip small label :disabled="item.disabled">{{ item.type.title }}</v-chip>
            </v-list-item-action>
          </template>
        </v-autocomplete>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="onCreate">
          Tilføj
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DatePick from './DatePick.vue';

export default {
  name: 'AddPersonLocationDialog',
  components: { DatePick },
  props: {
    personLocations: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      show: false,
      locations: [],
      selectedLocations: [],
      loading: true,
      creating: false
    }
  },
  computed: {
    availableLocations() {
      return this.locations.map(x => {
        return {
          ...x,
          disabled: this.personLocations.filter(x => x.isValid).map(y => y.customerLocationId).includes(x.id)
        }
      })
    }
  },
  async mounted() {
    try {
      const { data } = await this.$api.get('locations', {
        params: {
          customerId: this.$store.state.primaryCustomerId
        }
      });
  
      this.locations = data;
    } catch (error) {
      console.error(error);
      this.$notifier.showError()
    } finally {
      this.loading = false
    }
  },
  methods: {
    onCreate: async function() {
      this.creating = true

      try {
        const model = {
          personId: this.$route.params.id,
          customerLocationIds: this.selectedLocations
        }

        const { data } = await this.$api.post('person-locations', model)

        if (!data.success || data.errors.length) throw data.message ?? 'Something went wrong'
        this.$notifier.showSuccess({ message: 'Ændringerne blev gemt' })
        this.selectedLocations = []
        this.show = false
        this.$emit('success')
      } catch (error) {
        console.error(error)
        this.$notifier.showError({ message: 'Noget gik galt' })
      } finally {
        this.creating = false
      }
    }
  }
}
</script>